import { FormGroup, FormControl } from '@angular/forms';

export class ValidationService {
  private messages = {
    required: 'Required',
    invalidEmailAddress: 'Please enter a valid email address.',
    startsWhitespace: 'Input cannot start with a space.',
    endsWhitespace: 'Input cannot end with a space.',
    emailRequired: 'Email is required.',
    passwordRequired: 'Password is required.',
    passwordMinLength: 'Password should contain at least 8 characters.',
    digitRequired: 'Password should contain at least one number.',
    lowerCaseRequired: 'Password should contain at least one lower case letter.',
    upperCaseRequired: 'Password should contain at least one upper case letter.',
    specialCharsRequired: 'Password should contain at least one special character.',
    passwordMismatch: 'Passwords must match.',
    invalidPassword: 'Invalid password',
    datesNotInOrder: 'Select an end date that is after the start date.',
    duplicateName: 'A strategy with the same name exists for this institution.',
    duplicateNameWarning: 'Note: A plan already exists with this name, we suggest using a unique name.',
    duplicateResourceLinkName: 'A link already exists with this name. Please enter a unique name.',
    invalidExternalLinkUrl: 'Please attach a valid link.',
    externalLinkUrlRequired: 'Please add a web address, e.g. www.website.com.',
    attachmentFileNameRequired: 'Please add an attachment name.',
    attachmentDescriptionRequired: 'Please add a description.',
    attachmentFileRequired: 'Please add a file.',
    attachmentFileSize: 'File size exceeds 10 MB limit.',
    attachmentFileType: 'Please attach a valid file.',
    duplicateKeyMeasure: 'This statement already exists, please enter a new key measure.'
  };

  constructor() { }

  getValidatorErrorMessage(key: string) {
    return this.messages[key] || key;
  }

  getMaxLengthErrorMessage(maxChars: number): string {
    return `Max of ${maxChars} characters`;
  }

  getMinNumberErrorMessage(min: number): string {
    return `Cannot be less than ${min}`;
  }

  matchingPasswords(passwordKey: string, passwordConfirmationKey: string) {
    return (group: FormGroup) => {
      const passwordInput = group.controls[passwordKey];
      const passwordConfirmationInput = group.controls[passwordConfirmationKey];
      if (passwordInput.value && passwordConfirmationInput.value && passwordInput.value !== passwordConfirmationInput.value) {
        return passwordConfirmationInput.setErrors({passwordMismatch: true});
      }
    };
  }

  spaceChecker(control: FormControl) {
    if (control.value) {
      if (control.value.charAt(0) === ' ') {
        return { startsWhitespace: true };
      }
      if (control.value.slice(-1) === ' ') {
        return { endsWhitespace: true };
      }
      return null;
    } else {
      return null;
    }
  }

  passwordValidator(control: FormControl) {
    return !control.value ? {passwordRequired: true} : null;
  }

  emailValidator(control: FormControl) {
    // tslint:disable-next-line:max-line-length
    const emailPattern = new RegExp(/[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/);
    return !control.value ? {emailRequired: true} : emailPattern.test(control.value) ? null : { invalidEmailAddress: true };
  }

  resourceLinkValidator(control: FormControl) {
    const whiteSpace = new RegExp(/\s/g);
    // tslint:disable-next-line:max-line-length
    const linkPattern = new RegExp(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/);
    const controlValue = control.value;
    if (!controlValue) {
      return { externalLinkUrlRequired: true };
    } else if (!linkPattern.test(controlValue)) {
      return { invalidExternalLinkUrl: true };
    } else if (controlValue.replace(whiteSpace, '').length !== controlValue.length) {
      return { invalidExternalLinkUrl: true };
    }
  }

  public validateDatesInOrder(startDateKey: string, endDateKey: string) {
    return (group: FormGroup) => {
      const startDateInput = group.controls[startDateKey];
      const endDateInput = group.controls[endDateKey];
      if (startDateInput.value && endDateInput.value) {
        startDateInput.value.setHours(0, 0, 0, 0) > endDateInput.value.setHours(0, 0, 0, 0) ?
          endDateInput.setErrors({ datesNotInOrder: true }) : endDateInput.setErrors(null);
      } else {
        endDateInput.setErrors(null);
      }
    };
  }
}
